/* PhoneHub mobile tab bar v3 + photo-first Shop / My Phone sheets +
   "Shop for your <phone>" coach mark. No dependencies.
   v3: sheet images hydrate (data-src → src) on the sheet's first open, fade in
   on load and fall back to a letter tile on error; device art (homepage
   ph-device-icon SVGs) is cloned from the model cards with unique gradient ids;
   the Home mascot loads after window load; category cards stagger in once. */
(function () {
  'use strict';

  var DEVICE_KEY = 'ph:device';
  var DETECTED_KEY = 'ph:device-detected';
  var POP_KEY = 'ph:pop-shown';
  var DISMISS_FRACTION = 0.25;
  var DISMISS_VELOCITY = 0.11; // px/ms
  var KB_THRESHOLD = 150;
  var POP_LIFETIME = 8000;
  var POP_SCROLL = 300;
  var docEl = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function reduced() { return !!(reduceMotion && reduceMotion.matches); }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) {} } }

  function readJSON(store, key) {
    try {
      var d = JSON.parse(store.getItem(key) || 'null');
      return d && d.title && d.url ? d : null;
    } catch (e) { return null; }
  }
  function readDevice() { try { return readJSON(localStorage, DEVICE_KEY); } catch (e) { return null; } }
  function writeDevice(d) { try { localStorage.setItem(DEVICE_KEY, JSON.stringify({ title: d.title, url: d.url })); } catch (e) {} }
  function readDetected() { try { return readJSON(localStorage, DETECTED_KEY); } catch (e) { return null; } }
  function writeDetected(d) { try { localStorage.setItem(DETECTED_KEY, JSON.stringify(d)); } catch (e) {} }
  function popShown() { try { return sessionStorage.getItem(POP_KEY) === '1'; } catch (e) { return false; } }
  function markPopShown() { try { sessionStorage.setItem(POP_KEY, '1'); } catch (e) {} }

  function rubberband(overshoot, dimension) {
    var c = 0.55;
    return (overshoot * dimension * c) / (dimension + c * Math.abs(overshoot));
  }

  function money(v) {
    var n = parseFloat(v);
    return isNaN(n) ? '' : '$' + n.toFixed(2);
  }

  function sizedImage(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function searchUrl(model, suffix) {
    return '/search?q=' + encodeURIComponent(model + ' ' + suffix).replace(/%20/g, '+') + '&type=product';
  }

  function isPlainClick(e) {
    return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
  }

  /* ------------------------------------------------------------ images */
  // Give a deferred image its real source (sizes is already in the markup).
  function loadImg(img) {
    var src = img.getAttribute('data-src');
    if (!src) return;
    var set = img.getAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    if (set) img.setAttribute('srcset', set);
    img.setAttribute('src', src);
    if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
  }

  // Never show a broken image: swap in the letter tile (or drop decorative art).
  function imgFallback(img) {
    var letter = img.getAttribute('data-letter');
    if (letter && img.parentNode) {
      var span = document.createElement('span');
      span.className = 'phtb-letter';
      span.setAttribute('aria-hidden', 'true');
      span.textContent = letter;
      img.parentNode.replaceChild(span, img);
    } else if (img.parentNode) {
      img.parentNode.removeChild(img);
    }
  }

  // Cloned SVGs need their own gradient ids, or url(#…) may resolve to a copy
  // inside a hidden (display:none) subtree and paint nothing.
  var artSeq = 0;
  function uniqueIds(svg) {
    artSeq++;
    var map = {};
    $$('[id]', svg).forEach(function (el) {
      var n = el.id + '-c' + artSeq;
      map[el.id] = n;
      el.id = n;
    });
    $$('*', svg).forEach(function (el) {
      ['fill', 'stroke'].forEach(function (a) {
        var v = el.getAttribute(a);
        if (v && v.indexOf('url(#') === 0) {
          var id = v.slice(5, -1);
          if (map[id]) el.setAttribute(a, 'url(#' + map[id] + ')');
        }
      });
    });
    return svg;
  }

  /* ------------------------------------------------------------ detection */
  // iPhone: iOS hides the model. Portrait CSS screen size + DPR narrows it down to
  // the models that share that screen; when more than one of them is in the menu
  // the coach mark asks "Which iPhone do you have?" instead of guessing.
  // (Display Zoom reports a smaller size, so the pop-up also offers "Other model".)
  var IPHONE_SIZES = [
    [440, 956, 3, ['iPhone 18 Pro Max', 'iPhone 17 Pro Max', 'iPhone 16 Pro Max']],
    [402, 874, 3, ['iPhone 18 Pro', 'iPhone 17 Pro', 'iPhone 17', 'iPhone 16 Pro']],
    [420, 912, 3, ['iPhone 17 Air']],
    [430, 932, 3, ['iPhone 16 Plus', 'iPhone 15 Pro Max', 'iPhone 15 Plus', 'iPhone 14 Pro Max']],
    [393, 852, 3, ['iPhone 16', 'iPhone 15 Pro', 'iPhone 15', 'iPhone 14 Pro']],
    [428, 926, 3, ['iPhone 14 Plus', 'iPhone 13 Pro Max', 'iPhone 12 Pro Max']],
    [390, 844, 3, ['iPhone 16e', 'iPhone 14', 'iPhone 13 Pro', 'iPhone 13', 'iPhone 12 / 12 Pro']],
    [414, 896, 3, ['iPhone 11 Pro Max', 'iPhone X / XS / XR']],
    [414, 896, 2, ['iPhone 11', 'iPhone X / XS / XR']],
    [375, 812, 3, ['iPhone 11 Pro', 'iPhone X / XS / XR']],
    [375, 667, 2, ['iPhone 7 / 8']]
  ];
  // Samsung model-code prefixes → menu titles (longest prefix first).
  var SAMSUNG_CODES = [
    ['SM-S948', 'Galaxy S26 Ultra'],
    ['SM-S938', 'Galaxy S25 Ultra'],
    ['SM-S928', 'All Galaxy S series'],
    ['SM-S9', 'All Galaxy S series'],
    ['SM-F96', 'Galaxy Z Fold series'],
    ['SM-F95', 'Galaxy Z Fold series'],
    ['SM-F94', 'Galaxy Z Fold series'],
    ['SM-F76', 'Galaxy Z Flip series'],
    ['SM-F74', 'Galaxy Z Flip series'],
    ['SM-F73', 'Galaxy Z Flip series'],
    ['SM-A', '@samsung']
  ];

  // Returns the candidate model titles for this iPhone's screen, [] for an
  // unknown iPhone size, or null when this isn't an iPhone.
  function iphoneCandidates() {
    var ua = navigator.userAgent || '';
    if (!/iPhone/.test(ua) || /iPad/.test(ua)) return null;
    var w = Math.min(screen.width, screen.height);
    var h = Math.max(screen.width, screen.height);
    var dpr = Math.round(window.devicePixelRatio || 1);
    for (var i = 0; i < IPHONE_SIZES.length; i++) {
      var s = IPHONE_SIZES[i];
      if (s[0] === w && s[1] === h && s[2] === dpr) return s[3];
    }
    return [];
  }

  function samsungTitle(model) {
    if (!model) return null;
    var m = String(model).toUpperCase().match(/SM-[A-Z]\d{3}/);
    if (!m) return null;
    var code = m[0];
    for (var i = 0; i < SAMSUNG_CODES.length; i++) {
      if (code.indexOf(SAMSUNG_CODES[i][0]) === 0) return SAMSUNG_CODES[i][1];
    }
    return null;
  }

  // Resolves to { title, url, detected: true } using the menu's own links,
  // { ambiguous: true, options: [{ title, url }, …] } when several iPhones share the
  // screen size, or null.
  function detectDevice(root, done) {
    function byTitle(pane, title) {
      if (!pane || !title) return null;
      var want = title.toLowerCase();
      var hit = $$('.phtb-model', pane).filter(function (b) {
        return (b.getAttribute('data-title') || '').toLowerCase() === want;
      })[0];
      return hit ? { title: hit.getAttribute('data-title'), url: hit.getAttribute('data-url'), detected: true } : null;
    }
    function fromSamsung(t) {
      var pane = $('[data-phtb-pane="samsung"]', root);
      if (!t || !pane) return null;
      if (t === '@samsung') {
        var gt = pane.getAttribute('data-group-title');
        var gu = pane.getAttribute('data-group-url');
        return gt && gu && gu !== '#' ? { title: gt, url: gu, detected: true } : null;
      }
      return byTitle(pane, t);
    }

    try {
      var cands = iphoneCandidates();
      if (cands) {
        var ipPane = $('[data-phtb-pane="iphone"]', root);
        var seen = {};
        var opts = [];
        cands.forEach(function (t) {
          var hit = byTitle(ipPane, t);
          if (hit && !seen[hit.url]) { seen[hit.url] = true; opts.push({ title: hit.title, url: hit.url }); }
        });
        if (opts.length === 1) done({ title: opts[0].title, url: opts[0].url, detected: true });
        else if (opts.length > 1) done({ ambiguous: true, options: opts });
        else done(null);
        return;
      }

      var ua = navigator.userAgent || '';
      if (!/Android/i.test(ua)) { done(null); return; }
      var fromUa = fromSamsung(samsungTitle(ua));
      if (fromUa) { done(fromUa); return; }
      var uad = navigator.userAgentData;
      if (uad && typeof uad.getHighEntropyValues === 'function') {
        uad.getHighEntropyValues(['model']).then(function (v) {
          done(fromSamsung(samsungTitle(v && v.model)));
        }, function () { done(null); });
        return;
      }
    } catch (e) {}
    done(null);
  }

  /* ------------------------------------------------------------ TabBar */
  function TabBar(root) {
    this.root = root;
    this.bar = $('[data-phtb-bar]', root);
    this.ind = $('[data-phtb-ind]', root);
    this.backdrop = $('[data-phtb-backdrop]', root);
    this.pop = $('[data-phtb-pop]', root);
    this.sheets = {};
    var self = this;
    $$('[data-phtb-sheet]', root).forEach(function (s) { self.sheets[s.getAttribute('data-phtb-sheet')] = s; });
    this.openName = null;
    this.returnFocus = null;
    this.historyPushed = false;
    this.awaitingPop = false;
    this.pendingPush = null;
    this.productCache = {};
    this.fetchCtrl = null;
    this.drag = null;
    this.saved = readDevice();
    this.detected = null;
    this.indIndex = this.pageIndex();
    this.staggered = false;
    this.tabArt = $('[data-phtb-tab-art]', this.bar);
    this.tabArtFallback = this.tabArt ? this.tabArt.innerHTML : '';

    this.bindImages();
    this.loadMascot();
    this.bindTabs();
    this.bindSheets();
    this.bindPhone();
    this.bindCart();
    this.bindPop();
    this.renderDevice(false);

    // Transitions on the indicator only after first paint.
    var bar = this.bar;
    setTimeout(function () { if (bar) bar.classList.add('is-ready'); }, 60);

    if (history.state && history.state.phtbSheet) {
      try { history.replaceState(null, ''); } catch (e) {}
    }

    if (root.getAttribute('data-detect') !== 'false') {
      detectDevice(root, function (d) {
        if (d && d.ambiguous) {
          // Several iPhones share this screen: don't guess, ask in the coach mark.
          self.choices = d.options;
          try { localStorage.removeItem(DETECTED_KEY); } catch (e) {}
          if (self.detected) { self.detected = null; self.renderDevice(false); }
        } else if (d) {
          self.detected = d;
          writeDetected(d);
          self.renderDevice(false);
        } else if (!self.saved) {
          // A previous detection is still a valid default on this phone.
          self.detected = readDetected();
          if (self.detected) self.renderDevice(false);
        }
        self.schedulePop();
      });
    }
  }

  TabBar.prototype.device = function () { return this.saved || this.detected; };

  TabBar.prototype.tabFor = function (name) {
    return $('[data-phtb-open="' + name + '"]', this.bar);
  };

  TabBar.prototype.pageIndex = function () {
    var p = $('[data-phtb-page]', this.bar);
    return p ? parseInt(p.getAttribute('data-phtb-i'), 10) : -1;
  };

  /* ---------------- sliding indicator ---------------- */
  TabBar.prototype.setIndicator = function (i) {
    var ind = this.ind;
    if (!ind) return;
    var prev = this.indIndex;
    this.indIndex = i;
    var pop = i !== prev && !reduced() && this.bar.classList.contains('is-ready');
    $$('.phtb-tab[data-phtb-i]', this.bar).forEach(function (t) {
      var on = parseInt(t.getAttribute('data-phtb-i'), 10) === i;
      t.classList.toggle('is-active', on);
      if (on && pop) {
        // 0.9 (press) → 1.06 → 1, all transitions, so a rapid re-tap retargets.
        clearTimeout(t._phtbPop);
        t.classList.add('is-pop');
        t._phtbPop = setTimeout(function () { t.classList.remove('is-pop'); }, 170);
      }
    });
    if (i < 0) { ind.classList.remove('is-on'); return; }
    var x = 'translateX(' + (i * 100) + '%)';
    if (prev < 0 || !ind.classList.contains('is-on')) {
      // Appearing from nothing: place it without sliding, then fade in.
      ind.classList.add('is-snap');
      ind.style.transform = x;
      void ind.offsetWidth;
      ind.classList.add('is-on');
      ind.classList.remove('is-snap');
    } else {
      ind.style.transform = x;
    }
  };

  TabBar.prototype.bindTabs = function () {
    var self = this;
    $$('[data-phtb-open]', this.bar).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.hidePop();
        var name = btn.getAttribute('data-phtb-open');
        if (self.openName === name) self.close();
        else self.open(name, btn);
      });
    });
    // Home / Deals: move the pill on press (navigation follows).
    $$('a.phtb-tab[data-phtb-i]', this.bar).forEach(function (a) {
      a.addEventListener('click', function (e) {
        self.hidePop();
        if (!isPlainClick(e)) return;
        self.setIndicator(parseInt(a.getAttribute('data-phtb-i'), 10));
      });
    });
    var cart = $('[data-phtb-cart]', this.bar);
    if (cart) cart.addEventListener('click', function () { self.hidePop(); });
    // Restored from bfcache after following a tab: put the pill back.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && !self.openName) self.setIndicator(self.pageIndex());
    });
  };

  /* ---------------- open / close ---------------- */
  TabBar.prototype.open = function (name, trigger) {
    var sheet = this.sheets[name];
    if (!sheet) return;
    var prev = this.openName;
    if (prev === name) return;
    this.hidePop();

    if (prev) {
      this.hideSheet(prev);
    } else {
      this.returnFocus = trigger || this.tabFor(name) || document.activeElement;
      docEl.classList.add('phtb-sheet-open');
      this.backdrop.classList.add('is-open');
      this.pushHistory(name);
    }

    this.openName = name;
    this.hydrate(sheet);
    sheet.removeAttribute('inert');
    sheet.style.removeProperty('transform');
    sheet.classList.add('is-open');
    var tab = this.tabFor(name);
    if (tab) {
      tab.setAttribute('aria-expanded', 'true');
      this.setIndicator(parseInt(tab.getAttribute('data-phtb-i'), 10));
    }
    if (name === 'phone') this.onPhoneOpen();
    if (name === 'shop') this.staggerCats(sheet);

    focusEl($('[data-phtb-close]', sheet) || sheet);
  };

  TabBar.prototype.hideSheet = function (name) {
    var sheet = this.sheets[name];
    if (!sheet) return;
    sheet.classList.remove('is-open', 'is-dragging');
    sheet.style.removeProperty('transform');
    sheet.setAttribute('inert', '');
    var tab = this.tabFor(name);
    if (tab) tab.setAttribute('aria-expanded', 'false');
    var self = this;
    clearTimeout(sheet._phtbReset);
    sheet._phtbReset = setTimeout(function () {
      if (self.openName !== name) self.resetPanels(sheet);
    }, 300);
    if (name === 'phone' && this.fetchCtrl) {
      this.fetchCtrl.abort();
      this.fetchCtrl = null;
    }
  };

  TabBar.prototype.close = function (fromPop) {
    var name = this.openName;
    if (!name) return;
    this.hideSheet(name);
    this.openName = null;
    this.backdrop.classList.remove('is-open');
    this.backdrop.style.removeProperty('opacity');
    docEl.classList.remove('phtb-sheet-open');
    this.setIndicator(this.pageIndex());

    if (this.historyPushed) {
      this.historyPushed = false;
      if (!fromPop) {
        this.awaitingPop = true;
        try { history.back(); } catch (e) { this.awaitingPop = false; }
      }
    }

    var rf = this.returnFocus;
    this.returnFocus = null;
    if (rf && typeof rf.focus === 'function' && document.contains(rf)) focusEl(rf);
  };

  /* ---------------- history (Android back closes the sheet) ---------------- */
  TabBar.prototype.pushHistory = function (name) {
    if (this.awaitingPop) {
      // a history.back() from the previous close hasn't landed yet
      this.pendingPush = name;
      return;
    }
    try {
      history.pushState({ phtbSheet: name }, '');
      this.historyPushed = true;
    } catch (e) {}
  };

  TabBar.prototype.onPopState = function () {
    if (this.awaitingPop) {
      this.awaitingPop = false;
      if (this.pendingPush && this.openName) {
        var n = this.pendingPush;
        this.pendingPush = null;
        this.pushHistory(n);
      }
      this.pendingPush = null;
      return;
    }
    if (this.openName) {
      this.historyPushed = false;
      this.close(true);
    }
  };

  /* ---------------- sheet internals ---------------- */
  TabBar.prototype.bindSheets = function () {
    var self = this;
    this.backdrop.addEventListener('click', function () { self.close(); });

    Object.keys(this.sheets).forEach(function (name) {
      var sheet = self.sheets[name];

      $$('[data-phtb-close]', sheet).forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });

      sheet.addEventListener('keydown', function (e) { self.onKeydown(e, sheet); });

      // Links inside a sheet replace our pushed history entry, so Back from
      // the next page returns here (with the sheet closed) — no dead entry.
      sheet.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href]');
        if (!a || !sheet.contains(a) || !isPlainClick(e) || a.target === '_blank') return;
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) === '#') { e.preventDefault(); return; }
        if (a.origin && a.origin !== location.origin) return;
        if (self.historyPushed) {
          e.preventDefault();
          location.replace(a.href);
        }
      });

      // Drill-down panels
      $$('[data-phtb-panel]', sheet).forEach(function (btn) {
        btn.addEventListener('click', function () { self.openPanel(sheet, btn); });
      });
      $$('[data-phtb-back]', sheet).forEach(function (btn) {
        btn.addEventListener('click', function () { self.closePanel(sheet); });
      });

      $$('[data-phtb-goto]', sheet).forEach(function (btn) {
        btn.addEventListener('click', function () { self.open(btn.getAttribute('data-phtb-goto')); });
      });

      // Drag to dismiss: handle/header with pointer events…
      var head = $('[data-phtb-drag]', sheet);
      if (head) {
        head.addEventListener('pointerdown', function (e) { self.onPointerDown(e, sheet, head); });
      }
      // …and the content via touch events, only when scrolled to the top
      // and the finger moves down (so normal scrolling keeps pan-y).
      sheet.addEventListener('touchstart', function (e) { self.onTouchStart(e, sheet); }, { passive: true });
      sheet.addEventListener('touchmove', function (e) { self.onTouchMove(e, sheet); }, { passive: false });
      sheet.addEventListener('touchend', function (e) { self.onTouchEnd(e, sheet); }, { passive: true });
      sheet.addEventListener('touchcancel', function (e) { self.onTouchEnd(e, sheet); }, { passive: true });
    });
  };

  TabBar.prototype.onKeydown = function (e, sheet) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.stopPropagation();
      this.close();
      return;
    }
    if (e.key !== 'Tab') return;
    var items = $$('a[href], button:not([disabled]), input:not([type="hidden"]), summary, [tabindex]:not([tabindex="-1"])', sheet).filter(function (el) {
      return !el.closest('[inert]') && !el.closest('[hidden]') && el.getClientRects().length > 0;
    });
    if (!items.length) { e.preventDefault(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === sheet)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  TabBar.prototype.openPanel = function (sheet, btn) {
    var panel = document.getElementById(btn.getAttribute('data-phtb-panel'));
    if (!panel) return;
    var main = $('[data-phtb-main]', sheet);
    clearTimeout(panel._phtbHide);
    panel.removeAttribute('inert');
    panel.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    sheet._phtbPanelBtn = btn;
    var scroller = $('[data-phtb-scroll]', panel);
    if (scroller) scroller.scrollTop = 0;
    if (main) main.setAttribute('inert', '');
    focusEl($('[data-phtb-back]', panel));
  };

  TabBar.prototype.closePanel = function (sheet) {
    var panel = $('[data-phtb-panel-el].is-open', sheet);
    if (!panel) return;
    var main = $('[data-phtb-main]', sheet);
    panel.classList.remove('is-open');
    panel.setAttribute('inert', '');
    if (main) main.removeAttribute('inert');
    var btn = sheet._phtbPanelBtn;
    sheet._phtbPanelBtn = null;
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      focusEl(btn);
    }
  };

  // Snap panels shut with no animation once the sheet is off screen.
  TabBar.prototype.resetPanels = function (sheet) {
    $$('[data-phtb-panel-el].is-open', sheet).forEach(function (p) {
      p.style.transition = 'none';
      p.classList.remove('is-open');
      p.setAttribute('inert', '');
      void p.offsetWidth;
      p.style.removeProperty('transition');
    });
    $$('[data-phtb-panel][aria-expanded="true"]', sheet).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var main = $('[data-phtb-main]', sheet);
    if (main) main.removeAttribute('inert');
    sheet._phtbPanelBtn = null;
  };

  /* ---------------- images, mascot, stagger ---------------- */
  TabBar.prototype.bindImages = function () {
    // load/error don't bubble: listen in the capture phase on the root.
    this.root.addEventListener('load', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('phtb-img')) t.classList.add('is-loaded');
    }, true);
    this.root.addEventListener('error', function (e) {
      var t = e.target;
      if (t && t.tagName === 'IMG' && t.classList.contains('phtb-img')) imgFallback(t);
    }, true);
  };

  // First open only: nothing in a sheet downloads before the visitor asks for it.
  TabBar.prototype.hydrate = function (scope) {
    if (!scope || scope._phtbHydrated) return;
    scope._phtbHydrated = true;
    $$('img[data-src]', scope).forEach(loadImg);
  };

  // The Home mascot is not needed for first paint: fetch it once the page has
  // loaded and the main thread is idle; the house icon stays if it fails.
  TabBar.prototype.loadMascot = function () {
    var img = $('[data-phtb-late-src]', this.bar);
    if (!img) return;
    function go() {
      var u = img.getAttribute('data-phtb-late-src');
      if (!u) return;
      img.removeAttribute('data-phtb-late-src');
      img.onload = function () { var ic = img.closest && img.closest('.phtb-tab__icon'); if (img.naturalWidth && ic) ic.classList.add('has-avatar'); };
      img.onerror = function () { var w = img.parentNode; if (w && w.parentNode) w.parentNode.removeChild(w); };
      img.src = u;
    }
    function idle() {
      if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 3000 });
      else setTimeout(go, 600);
    }
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
  };

  // Category cards rise in 30ms apart, first Shop open only (max 8 cards).
  TabBar.prototype.staggerCats = function (sheet) {
    if (this.staggered) return;
    this.staggered = true;
    if (reduced()) return;
    var grid = $('[data-phtb-cats]', sheet);
    if (!grid) return;
    var cards = $$('.phtb-cat', grid).slice(0, 8);
    if (!cards.length) return;
    grid.classList.add('is-staggering');
    cards.forEach(function (c, i) {
      c.classList.add('is-pre');
      c.style.transitionDelay = (i * 30) + 'ms';
    });
    void grid.offsetWidth;
    requestAnimationFrame(function () {
      cards.forEach(function (c) { c.classList.remove('is-pre'); });
    });
    setTimeout(function () {
      grid.classList.remove('is-staggering');
      cards.forEach(function (c) { c.style.removeProperty('transition-delay'); });
    }, cards.length * 30 + 260);
  };

  /* ---------------- device art (homepage ph-device-icon) ---------------- */
  TabBar.prototype.artFor = function (d) {
    var src = null;
    if (d) {
      var card = $$('.phtb-model', this.root).filter(function (b) { return b.getAttribute('data-url') === d.url; })[0];
      if (card) src = $('.phtb-model__dev > svg, .phtb-model__dev > img, .phtb-model__dev > .phtb-letter', card);
    }
    if (src) {
      var node = src.cloneNode(true);
      if (node.tagName && node.tagName.toLowerCase() === 'svg') return uniqueIds(node);
      if (node.tagName === 'IMG') loadImg(node);
      return node;
    }
    var tpl = $('[data-phtb-generic-art]', this.root);
    var first = tpl && tpl.content && tpl.content.firstElementChild;
    return first ? first.cloneNode(true) : null;
  };

  TabBar.prototype.renderArt = function (d) {
    var self = this;
    $$('[data-phtb-art]', this.root).forEach(function (slot) {
      var n = self.artFor(d);
      slot.innerHTML = '';
      if (n) slot.appendChild(n);
    });
    // My Phone tab: the model's own device icon once we know it.
    var tab = this.tabArt;
    if (!tab) return;
    var art = d ? this.artFor(d) : null;
    if (art && art.tagName && art.tagName.toLowerCase() === 'svg' && art.classList.contains('ph-svg')) {
      tab.innerHTML = '';
      tab.appendChild(art);
      tab.classList.add('has-dev');
    } else if (tab.classList.contains('has-dev') || !tab.firstElementChild) {
      tab.innerHTML = this.tabArtFallback;
      tab.classList.remove('has-dev');
    }
  };

  /* ---------------- drag to dismiss ---------------- */
  TabBar.prototype.dragStart = function (sheet, y) {
    this.drag = {
      sheet: sheet,
      startY: y,
      dy: 0,
      height: sheet.getBoundingClientRect().height || 1,
      samples: [{ y: y, t: performance.now() }],
      raf: 0
    };
    sheet.classList.add('is-dragging');
    this.backdrop.style.transition = 'none';
  };

  TabBar.prototype.dragMove = function (y) {
    var d = this.drag;
    if (!d) return;
    var raw = y - d.startY;
    d.dy = raw >= 0 ? raw : -rubberband(-raw, d.height);
    var now = performance.now();
    d.samples.push({ y: y, t: now });
    while (d.samples.length > 2 && now - d.samples[0].t > 100) d.samples.shift();
    if (d.raf) return;
    var self = this;
    d.raf = requestAnimationFrame(function () {
      d.raf = 0;
      if (self.drag !== d) return;
      d.sheet.style.transform = 'translate3d(0,' + d.dy + 'px,0)';
      var progress = Math.max(0, Math.min(1, d.dy / d.height));
      self.backdrop.style.opacity = String(1 - progress);
    });
  };

  TabBar.prototype.dragEnd = function () {
    var d = this.drag;
    if (!d) return;
    this.drag = null;
    if (d.raf) cancelAnimationFrame(d.raf);
    var first = d.samples[0];
    var last = d.samples[d.samples.length - 1];
    var dt = last.t - first.t;
    var velocity = dt > 0 ? (last.y - first.y) / dt : 0;

    // Release: let the CSS transition carry it from the current position.
    d.sheet.classList.remove('is-dragging');
    this.backdrop.style.removeProperty('transition');

    if (d.dy > d.height * DISMISS_FRACTION || (velocity > DISMISS_VELOCITY && d.dy > 0)) {
      this.close();
    } else {
      d.sheet.style.removeProperty('transform');
      this.backdrop.style.removeProperty('opacity');
    }
  };

  TabBar.prototype.onPointerDown = function (e, sheet, head) {
    if (this.drag || !e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
    if (e.target.closest('button, a')) return; // let the close button tap through
    var self = this;
    var id = e.pointerId;
    try { head.setPointerCapture(id); } catch (err) {}
    this.dragStart(sheet, e.clientY);

    function move(ev) { if (ev.pointerId === id) self.dragMove(ev.clientY); }
    function up(ev) {
      if (ev.pointerId !== id) return;
      head.removeEventListener('pointermove', move);
      head.removeEventListener('pointerup', up);
      head.removeEventListener('pointercancel', up);
      try { head.releasePointerCapture(id); } catch (err) {}
      self.dragEnd();
    }
    head.addEventListener('pointermove', move, { passive: true });
    head.addEventListener('pointerup', up);
    head.addEventListener('pointercancel', up);
  };

  TabBar.prototype.onTouchStart = function (e) {
    if (e.touches.length !== 1 || this.drag) { this.touch = null; return; }
    var t = e.touches[0];
    if (e.target.closest('[data-phtb-drag]')) { this.touch = null; return; } // pointer path owns the header
    var scroller = e.target.closest('[data-phtb-scroll]');
    this.touch = { x: t.clientX, y: t.clientY, scroller: scroller, decided: false, active: false };
  };

  TabBar.prototype.onTouchMove = function (e, sheet) {
    var tc = this.touch;
    if (!tc) return;
    if (e.touches.length !== 1) {
      if (tc.active) this.dragEnd();
      this.touch = null;
      return;
    }
    var t = e.touches[0];
    if (!tc.decided) {
      var dx = t.clientX - tc.x;
      var dy = t.clientY - tc.y;
      var atTop = !tc.scroller || tc.scroller.scrollTop <= 0;
      var candidate = atTop && dy > 0 && dy >= Math.abs(dx);
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) {
        // Hold the scroller still while a downward pull at the top is ambiguous,
        // otherwise the browser claims the gesture and later moves can't be cancelled.
        if (candidate && e.cancelable) e.preventDefault();
        return;
      }
      tc.decided = true;
      if (candidate) {
        tc.active = true;
        this.dragStart(sheet, tc.y);
      } else {
        this.touch = null;
        return;
      }
    }
    if (tc.active) {
      if (e.cancelable) e.preventDefault();
      this.dragMove(t.clientY);
    }
  };

  TabBar.prototype.onTouchEnd = function () {
    var tc = this.touch;
    this.touch = null;
    if (tc && tc.active) this.dragEnd();
  };

  /* ---------------- My Phone ---------------- */
  TabBar.prototype.selectSeg = function (seg) {
    var sheet = this.sheets.phone;
    if (!sheet || !$('[data-phtb-seg="' + seg + '"]', sheet)) return;
    $$('[data-phtb-seg]', sheet).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-phtb-seg') === seg ? 'true' : 'false'); });
    $$('[data-phtb-pane]', sheet).forEach(function (p) { p.hidden = p.getAttribute('data-phtb-pane') !== seg; });
  };

  TabBar.prototype.choose = function (d, animate) {
    if (!d || !d.title || !d.url) return;
    this.saved = { title: d.title, url: d.url };
    writeDevice(this.saved);
    this.renderDevice(animate);
    if (this.openName === 'phone') this.loadPopular();
  };

  TabBar.prototype.bindPhone = function () {
    var sheet = this.sheets.phone;
    if (!sheet) return;
    var self = this;
    this.picker = $('[data-phtb-picker]', sheet);
    this.deviceView = $('[data-phtb-device]', sheet);

    $$('[data-phtb-seg]', sheet).forEach(function (btn) {
      btn.addEventListener('click', function () { self.selectSeg(btn.getAttribute('data-phtb-seg')); });
    });

    $$('.phtb-model', sheet).forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.choose({ title: btn.getAttribute('data-title'), url: btn.getAttribute('data-url') }, true);
      });
    });

    $$('[data-phtb-change]', sheet).forEach(function (change) {
      change.addEventListener('click', function () {
        var d = self.device();
        if (d) {
          var pane = $$('[data-phtb-pane]', sheet).filter(function (p) {
            return $$('.phtb-model', p).some(function (b) { return b.getAttribute('data-url') === d.url; });
          })[0];
          if (pane) self.selectSeg(pane.getAttribute('data-phtb-pane'));
        }
        self.swapView(self.deviceView, self.picker, function () {
          focusEl($('.phtb-seg__btn[aria-pressed="true"]', sheet) || $('.phtb-model', sheet));
        });
      });
    });
  };

  TabBar.prototype.swapView = function (from, to, done) {
    if (!from || !to) return;
    var scroller = to.closest('[data-phtb-scroll]');
    if (from.hidden) { to.hidden = false; if (done) done(); return; }
    from.classList.add('is-fading');
    setTimeout(function () {
      from.hidden = true;
      from.classList.remove('is-fading');
      to.classList.add('is-fading');
      to.hidden = false;
      if (scroller) scroller.scrollTop = 0;
      void to.offsetWidth;
      to.classList.remove('is-fading');
      if (done) done();
    }, reduced() ? 0 : 180);
  };

  TabBar.prototype.renderDevice = function (animate) {
    var d = this.device();
    var isDetected = !this.saved && !!this.detected;
    var root = this.root;
    this.renderArt(d);

    // Shop sheet device card
    var k = $('[data-phtb-dev-k]', root);
    var t = $('[data-phtb-dev-t]', root);
    var cta = $('[data-phtb-dev-cta]', root);
    if (k && t && cta) {
      if (d) { k.textContent = 'Accessories for'; t.textContent = d.title; cta.textContent = 'Change'; }
      else { k.textContent = 'Pick your phone'; t.textContent = 'See what fits'; cta.textContent = 'Choose'; }
    }

    if (!this.picker || !this.deviceView) return;
    if (!d) {
      this.deviceView.hidden = true;
      this.picker.hidden = false;
      return;
    }
    $$('[data-phtb-dev-title]', this.deviceView).forEach(function (el) { el.textContent = d.title; });
    // One line, one Change control: detected → "not your phone?", saved → remembered.
    var detT = $('[data-phtb-detected-t]', this.deviceView);
    if (detT) detT.textContent = isDetected ? 'Detected automatically — not your phone?' : 'Remembered on this phone ·';
    var model = d.title;
    var links = {
      all: d.url,
      cases: d.url,
      screen: searchUrl(model, 'screen protector'),
      camera: searchUrl(model, 'camera protector'),
      magsafe: searchUrl(model, 'magsafe')
    };
    $$('[data-phtb-sc]', this.deviceView).forEach(function (a) {
      var u = links[a.getAttribute('data-phtb-sc')];
      if (u) a.setAttribute('href', u);
    });
    var pop = $('[data-phtb-popular]', this.deviceView);
    if (pop) pop.hidden = true;

    if (animate) this.swapView(this.picker, this.deviceView);
    else { this.picker.hidden = true; this.deviceView.hidden = false; }
  };

  TabBar.prototype.onPhoneOpen = function () {
    if (this.device()) this.loadPopular();
  };

  TabBar.prototype.loadPopular = function () {
    var d = this.device();
    var view = this.deviceView;
    if (!d || !view) return;
    var pop = $('[data-phtb-popular]', view);
    var row = $('[data-phtb-cards]', view);
    if (!pop || !row) return;
    var key = d.url;
    var self = this;

    if (this.productCache[key]) { this.renderCards(this.productCache[key], pop, row); return; }

    // skeletons
    var sk = '';
    for (var i = 0; i < 3; i++) {
      sk += '<div class="phtb-card phtb-card--sk" aria-hidden="true"><span class="phtb-card__img"></span><span class="phtb-card__t">&nbsp;</span><span class="phtb-card__p"></span></div>';
    }
    row.innerHTML = sk;
    pop.hidden = false;
    pop.setAttribute('aria-busy', 'true');

    if (this.fetchCtrl) this.fetchCtrl.abort();
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    this.fetchCtrl = ctrl;
    var base = key.split('?')[0].replace(/\/$/, '');

    fetch(base + '/products.json?limit=6', { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (json) {
        if (self.fetchCtrl === ctrl) self.fetchCtrl = null;
        var products = (json && json.products) || [];
        self.productCache[key] = products;
        var cur = self.device();
        if (cur && cur.url === key) self.renderCards(products, pop, row);
      })
      .catch(function (err) {
        if (self.fetchCtrl === ctrl) self.fetchCtrl = null;
        if (err && err.name === 'AbortError') return;
        self.productCache[key] = [];
        pop.hidden = true;
        row.innerHTML = '';
      });
  };

  TabBar.prototype.renderCards = function (products, pop, row) {
    pop.removeAttribute('aria-busy');
    if (!products || !products.length) { pop.hidden = true; row.innerHTML = ''; return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var frag = document.createDocumentFragment();
    products.slice(0, 6).forEach(function (p) {
      var v = (p.variants && p.variants[0]) || {};
      var a = document.createElement('a');
      a.className = 'phtb-card';
      a.href = root + 'products/' + p.handle;
      var img = document.createElement('img');
      img.className = 'phtb-card__img phtb-img';
      img.setAttribute('data-letter', (p.title || '').trim().charAt(0).toUpperCase());
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = '';
      img.width = 300;
      img.height = 300;
      var src = p.images && p.images[0] && p.images[0].src;
      if (src) img.src = sizedImage(src, 300);
      var t = document.createElement('span');
      t.className = 'phtb-card__t';
      t.textContent = p.title || '';
      var pr = document.createElement('span');
      pr.className = 'phtb-card__p';
      pr.textContent = money(v.price);
      var cmp = parseFloat(v.compare_at_price);
      if (!isNaN(cmp) && cmp > parseFloat(v.price)) {
        var s = document.createElement('s');
        s.textContent = money(cmp);
        pr.appendChild(s);
      }
      a.appendChild(img);
      a.appendChild(t);
      a.appendChild(pr);
      frag.appendChild(a);
    });
    row.innerHTML = '';
    row.appendChild(frag);
    row.scrollLeft = 0;
    pop.hidden = false;
  };

  /* ---------------- "Shop for your <phone>" coach mark ---------------- */
  TabBar.prototype.bindPop = function () {
    var pop = this.pop;
    if (!pop) return;
    var self = this;
    var x = $('[data-phtb-pop-close]', pop);
    if (x) x.addEventListener('click', function () { self.hidePop(); });
    var go = $('[data-phtb-pop-go]', pop);
    if (go) {
      go.addEventListener('click', function () {
        var d = self.device();
        self.hidePop();
        if (d) self.choose(d, false);
        self.open('phone', self.tabFor('phone'));
      });
    }
    pop.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { self.hidePop(); focusEl(self.tabFor('phone')); }
    });
  };

  TabBar.prototype.barVisible = function () {
    var b = document.body;
    if (!this.bar || this.openName) return false;
    if (b.classList.contains('product-template') || b.classList.contains('modal-show') ||
        b.classList.contains('modal-showing') || b.classList.contains('search-open')) return false;
    if (docEl.classList.contains('phtb-kb')) return false;
    if (!this.bar.getClientRects().length) return false; // ≥768px: display none
    var cs = getComputedStyle(this.bar);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  };

  TabBar.prototype.schedulePop = function () {
    var self = this;
    var d = this.device();
    var asking = !d && this.choices && this.choices.length > 1;
    if (!this.pop || (!d && !asking) || popShown()) return;
    if (window.Shopify && Shopify.designMode) return;
    var delay = parseInt(this.root.getAttribute('data-popup-delay'), 10);
    if (isNaN(delay) || delay < 0) delay = 1200;
    clearTimeout(this._popT);
    this._popT = setTimeout(function () { self.showPop(); }, delay);
  };

  // Coach mark content: "Shop for your <phone>" (one phone known) or
  // "Which iPhone do you have?" with one button per candidate model.
  TabBar.prototype.renderPopMode = function (options, d) {
    var pop = this.pop;
    var card = $('.phtb-pop__card', pop);
    var text = $('#PhtbPopText', pop) || $('.phtb-pop__text', pop);
    var go = $('[data-phtb-pop-go]', pop);
    var old = $('[data-phtb-pop-choices]', pop);
    if (old) old.parentNode.removeChild(old);
    pop.classList.toggle('phtb-pop--ask', !!options);
    if (!options) {
      if (text) text.innerHTML = 'Shop for your <strong data-phtb-pop-name></strong>';
      var name = $('[data-phtb-pop-name]', pop);
      if (name) name.textContent = d.title;
      if (go) go.hidden = false;
      return;
    }
    if (text) text.innerHTML = '<strong>Which iPhone do you have?</strong>Pick yours to see what fits';
    if (go) go.hidden = true;
    var self = this;
    var box = document.createElement('div');
    box.className = 'phtb-pop__choices';
    box.setAttribute('data-phtb-pop-choices', '');
    options.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'phtb-pop__choice';
      b.textContent = o.title.replace(/^iPhone\s+/, '');
      b.setAttribute('aria-label', o.title);
      b.addEventListener('click', function () {
        self.choices = null;
        self.hidePop();
        self.choose({ title: o.title, url: o.url }, false);
        self.open('phone', self.tabFor('phone'));
      });
      box.appendChild(b);
    });
    var other = document.createElement('button');
    other.type = 'button';
    other.className = 'phtb-pop__other';
    other.textContent = 'Other model';
    other.addEventListener('click', function () {
      self.hidePop();
      self.open('phone', self.tabFor('phone'));
    });
    box.appendChild(other);
    if (card) card.appendChild(box);
  };

  TabBar.prototype.positionPop = function () {
    var pop = this.pop;
    var tab = this.tabFor('phone');
    if (!pop || !tab) return;
    var vw = docEl.clientWidth || window.innerWidth;
    var r = tab.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var w = pop.offsetWidth || Math.min(300, vw - 24);
    var left = Math.max(12, Math.min(cx - w / 2, vw - 12 - w));
    var arrow = Math.max(20, Math.min(cx - left, w - 20));
    pop.style.left = Math.round(left) + 'px';
    pop.style.setProperty('--phtb-pop-arrow', Math.round(arrow) + 'px');
    pop.style.setProperty('--phtb-pop-origin', Math.round(arrow) + 'px');
  };

  TabBar.prototype.showPop = function () {
    var pop = this.pop;
    var d = this.device();
    var asking = !d && this.choices && this.choices.length > 1;
    if (!pop || (!d && !asking) || popShown() || !this.barVisible()) return;
    markPopShown();
    this.renderPopMode(asking ? this.choices : null, d);
    pop.hidden = false;
    this.positionPop();
    void pop.offsetWidth;
    pop.classList.add('is-in');
    this.popOpen = true;

    var self = this;
    var startY = window.pageYOffset || 0;
    this._popLife = setTimeout(function () { self.hidePop(); }, asking ? POP_LIFETIME * 2 : POP_LIFETIME);
    this._popScroll = function () {
      if (Math.abs((window.pageYOffset || 0) - startY) > POP_SCROLL) self.hidePop();
    };
    this._popResize = function () { self.positionPop(); };
    window.addEventListener('scroll', this._popScroll, { passive: true });
    window.addEventListener('resize', this._popResize, { passive: true });
  };

  TabBar.prototype.hidePop = function () {
    clearTimeout(this._popT);
    var pop = this.pop;
    if (!pop || !this.popOpen) return;
    this.popOpen = false;
    clearTimeout(this._popLife);
    window.removeEventListener('scroll', this._popScroll);
    window.removeEventListener('resize', this._popResize);
    if (pop.contains(document.activeElement)) focusEl(this.tabFor('phone'));
    pop.classList.remove('is-in');
    clearTimeout(this._popHide);
    this._popHide = setTimeout(function () { pop.hidden = true; }, 160);
  };

  /* ---------------- Cart badge ---------------- */
  TabBar.prototype.bindCart = function () {
    var self = this;
    this.cartLink = $('[data-phtb-cart]', this.bar);
    this.badge = $('[data-phtb-badge]', this.bar);
    if (this.cartLink) {
      // The theme binds every [aria-controls="CartDrawer"] (our tab included)
      // to the drawer in CartDrawer.connectedCallback and preventDefaults the
      // click. This document-level fallback only runs if nothing handled it
      // (e.g. after a theme-editor section reload): open the drawer directly,
      // otherwise the link navigates to /cart.
      document.addEventListener('click', function (e) {
        var link = e.target.closest && e.target.closest('[data-phtb-cart]');
        if (!link || link !== self.cartLink || e.defaultPrevented || !isPlainClick(e)) return;
        var drawer = link.getAttribute('aria-controls') && document.getElementById(link.getAttribute('aria-controls'));
        if (drawer && typeof drawer.show === 'function') {
          e.preventDefault();
          drawer.show(link);
        }
      });
    }
    if (!this.badge) return;
    this.count = parseInt(this.badge.getAttribute('data-count'), 10) || 0;

    var hasPubsub = window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS;
    if (hasPubsub) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.cart && !ev.cart.errors && typeof ev.cart.item_count === 'number') self.setCount(ev.cart.item_count);
      });
    }
    document.addEventListener('cart:updated', function (ev) {
      var c = ev && ev.detail && ev.detail.cart;
      if (c && typeof c.item_count === 'number') self.setCount(c.item_count);
      else self.refetchCart();
    });
    if (!hasPubsub) {
      ['cart:refresh', 'product-ajax:added'].forEach(function (n) {
        document.addEventListener(n, function () { self.refetchCart(); });
      });
    }
    // Restored from bfcache: the count may have changed on another page.
    window.addEventListener('pageshow', function (e) { if (e.persisted) self.refetchCart(); });
  };

  TabBar.prototype.refetchCart = function () {
    var self = this;
    clearTimeout(this._cartT);
    this._cartT = setTimeout(function () {
      var url = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';
      fetch(url + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.item_count === 'number') self.setCount(c.item_count); })
        .catch(function () {});
    }, 250);
  };

  TabBar.prototype.setCount = function (n) {
    var b = this.badge;
    if (!b || n === this.count) return;
    var grew = n > this.count;
    this.count = n;
    b.textContent = n > 99 ? '99+' : String(n);
    b.setAttribute('data-count', String(n));
    b.hidden = n === 0;
    if (this.cartLink) this.cartLink.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    if (grew && n > 0 && !reduced()) {
      clearTimeout(this._bumpT);
      b.classList.add('is-bump');
      this._bumpT = setTimeout(function () { b.classList.remove('is-bump'); }, 110);
    }
  };

  /* ------------------------------------------------------------ globals */
  var instances = [];

  function current() { return instances[instances.length - 1]; }

  // On-screen keyboard: visualViewport shrinks by more than KB_THRESHOLD
  function watchKeyboard() {
    var vv = window.visualViewport;
    if (!vv) return;
    var base = vv.height;
    var raf = 0;
    function check() {
      raf = 0;
      if (Math.abs(vv.scale - 1) > 0.01) return; // pinch zoom, not a keyboard
      if (vv.height > base) base = vv.height;
      var kb = base - vv.height > KB_THRESHOLD;
      docEl.classList.toggle('phtb-kb', kb);
      if (kb) instances.forEach(function (i) { i.hidePop(); });
    }
    vv.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    window.addEventListener('orientationchange', function () {
      setTimeout(function () { base = vv.height; check(); }, 400);
    });
  }

  function init(scope) {
    $$('[data-phtb]', scope).forEach(function (root) {
      if (root._phtb) return;
      try {
        root._phtb = new TabBar(root);
        instances.push(root._phtb);
      } catch (e) {
        if (window.console) console.warn('[ph-tab-bar]', e);
      }
    });
  }

  try {
    init(document);
    watchKeyboard();
    window.addEventListener('popstate', function () {
      var inst = current();
      if (inst) inst.onPopState();
    });
    // Restored from bfcache (e.g. Back after following a link in a sheet):
    // the page comes back with the sheet still open, so close it in place.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      instances.forEach(function (inst) {
        if (inst.openName) { inst.historyPushed = false; inst.close(true); }
      });
    });
    // A theme drawer/modal opening hides the bar → hide the coach mark too.
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        var c = document.body.classList;
        if (c.contains('modal-show') || c.contains('modal-showing') || c.contains('search-open')) {
          instances.forEach(function (i) { i.hidePop(); });
        }
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('shopify:section:load', function (e) {
      instances = instances.filter(function (i) { return document.contains(i.root); });
      docEl.classList.remove('phtb-sheet-open');
      init(e.target);
    });
  } catch (e) {
    if (window.console) console.warn('[ph-tab-bar]', e);
  }
})();
